import { createContext, useContext } from 'react';
import { DEFAULT_REGION, type Region } from './region';

/**
 * Lo llena `UserLocaleProvider` (`fsd/app/locale`). Sin provider vale `DEFAULT_REGION`: un componente
 * de `fsd/` se puede montar suelto (tests, Storybook) sin romper.
 */
export const RegionContext = createContext<Region>(DEFAULT_REGION);

/** La región del usuario para formatear números y fechas. */
export function useRegion(): Region {
  return useContext(RegionContext);
}
